import CampaignModal from './CampaignModal';
import { formatDate } from '../../utilities';
import { CampaignName } from '../../templates';
import { Slug, Button } from '../../components';
import { useAppContext, useView } from '../../hooks';
import { useCampaignActions } from './useCampaignActions';
import { useCampaigns, CampaignsListTemplate } from '../../templates';

const getColor = (status: string): SlugColorType => {
  switch (status) {
    case 'active':
      return 'main';
    case 'inactive':
      return 'danger';
    case 'completed':
      return 'success';
    default:
      return 'main';
  }
};

const Campaigns = () => {
  const listResult = useCampaigns();
  const { refresh: refreshMeta } = useAppContext();
  const { refresh, reloading, initializing: fetching } = listResult;

  const {
    element: actionElement,
    isOpened,
    updating,
    initialValues,

    handleAdd,
    handleStartAdd,
    handleClose,
    handleStartDelete,
    handleEdit,
    handleStartEdit,
  } = useCampaignActions(() => {
    refresh();
    refreshMeta();
  });

  const { element: viewElemenet, handleView } = useView();

  const loading = fetching || updating;

  return (
    <>
      {actionElement}
      {viewElemenet}
      {isOpened && (
        <CampaignModal
          loading={loading}
          initialValues={initialValues}
          onClose={handleClose}
          onSumbit={initialValues ? handleEdit : handleAdd}
        />
      )}
      <CampaignsListTemplate
        listResult={listResult}
        buttons={
          <>
            <Button icon="refresh" loading={reloading} onClick={refresh}>
              Refresh
            </Button>
            <Button icon="plus" onClick={handleStartAdd}>
              Add Campaign
            </Button>
          </>
        }
        columns={[
          {
            header: 'Name',
            sortName: 'name',
            cellClassName: 'text-small font-semibold',
            getValue: ({ id, name }) => <CampaignName id={id} name={name} />,
          },
          {
            header: 'Status',
            sortName: 'status',
            cellClassName: 'max-w-[12rem]',
            getValue: ({ status }) => (
              <Slug
                text={status}
                color={getColor(status)}
                className="max-w-[10rem]"
              />
            ),
          },
          {
            header: 'Description',
            sortName: 'description',
            cellClassName: 'text-small',
            getValue: ({ description }) => description,
          },
          {
            header: 'Contacts',
            sortName: 'contact_count',
            cellClassName: 'text-small',
            getValue: ({ contact_count }) => (
              <Slug text={contact_count || 0} className="w-[3rem]" />
            ),
          },
          {
            header: 'Created',
            sortName: 'created_at',
            cellClassName: 'text-tiny',
            getValue: ({ created_at }) => formatDate(created_at),
          },
          {
            header: 'Actions',
            align: 'right',
            getValue: item => (
              <div className="flex flex-row gap-x-sm justify-end">
                <Button icon="eye" onClick={() => handleView(item)} />
                <Button
                  icon="edit"
                  type="primary"
                  onClick={() => handleStartEdit(item)}
                />
                <Button
                  icon="delete"
                  type="danger"
                  onClick={() => handleStartDelete(item)}
                />
              </div>
            ),
          },
        ]}
      />
    </>
  );
};

export default Campaigns;
